import { DocumentReference, ISoftDelete } from '@principle-theorem/shared';
import type Stripe from 'stripe';
import { IMarketingCampaignRun } from '../marketing/campaign-run';

export enum StripeInvoiceStatus {
  Unknown = 'unknown',
  Paid = 'paid',
  Void = 'void',
  Uncollectible = 'uncollectible',
}

export const DEFAULT_STRIPE_INVOICE_STATUS = StripeInvoiceStatus.Unknown;

export interface IStripeInvoiceData {
  id: string;
  status: string;
  number: string;
  total: number;
  amountPaid: number;
  hostedInvoiceUrl?: string;
  rawData: Stripe.Invoice;
}

export interface IStripeInvoice extends ISoftDelete {
  invoice: IStripeInvoiceData;
  creditGrantId?: string;
  campaignRunRef?: DocumentReference<IMarketingCampaignRun>;
}
